import axios from 'axios';
import { isValidLocaleValue } from 'utils/languageUtils';

// ---------------------------------------------------------------------------------------------------------------------

const AXIOS_INSTANCE = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_BASE_URL?.replace('{origin}', window.location.origin) ?? undefined,
  timeout: 0,
});

const paramsSerializer = (params) => {
  const searchParams = new URLSearchParams();
  searchParams.append('filters[app][$eq]', params.filters.app.$eq);
  searchParams.append('pagination[pageSize]', params.pagination.pageSize);
  searchParams.append('pagination[page]', params.pagination.page);
  searchParams.append('publicationState', params.publicationState);
  searchParams.append('locale', params.locale);
  if (Array.isArray(params.populate)) {
    params.populate.forEach((value) => {
      searchParams.append('populate', value);
    });
  }
  return searchParams.toString();
};

// ---------------------------------------------------------------------------------------------------------------------

export const fetchHeader = (locale) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_STRAPI_HEADER_URI ?? undefined, {
    params: {
      filters: { app: { $eq: 'cosmote' } },
      pagination: { pageSize: 10, page: 1 },
      publicationState: 'live',
      locale: isValidLocaleValue(locale) ? locale : 'el',
    },
    paramsSerializer: { serialize: paramsSerializer },
  });
};

export const fetchFooter = (locale) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_STRAPI_FOOTER_URI ?? undefined, {
    params: {
      filters: { app: { $eq: 'global' } },
      pagination: { pageSize: 10, page: 1 },
      populate: ['footerColumns', 'footerColumns.links', 'links', 'footerLogo'],
      publicationState: 'live',
      locale: isValidLocaleValue(locale) ? locale : 'el',
    },
    paramsSerializer: { serialize: paramsSerializer },
  });
};

export const fetchLocales = (locale) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_STRAPI_LOCALES_URI ?? undefined, {
    params: {
      publicationState: 'live',
      locale: isValidLocaleValue(locale) ? locale : 'el',
    },
  });
};

export const fetchRoamingImages = (locale, config = {}) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_STRAPI_ROAMING_IMAGES, {
    ...config,
    params: {
      locale: isValidLocaleValue(locale) ? locale : 'el',
      'populate[countryGrid][populate][imageGrouping]': '*',
      'populate[countryGrid][populate][countryList][populate]': '*',
      'populate[roamingBlock][populate]': '*',
      ...config.params,
    },
  });
};

export const fetchRoamingEuProducts = (locale, config = {}) => {
  return AXIOS_INSTANCE.get(process.env.REACT_APP_STRAPI_ROAMING_PRODUCTS, {
    ...config,
    params: {
      locale: isValidLocaleValue(locale) ? locale : 'el',
      'populate[PackageProgram][populate][image]': '*',
      'populate[PackageProgram][populate][Programs][populate][categories][populate][SVG]': '*',
      ...config.params,
    },
  });
};
